import React from 'react';
import { ensureAppEnv } from 'buzz_lib_ui';
import { AppNavProvider, ConfigProvider } from 'buzz_lib_contexts';
import { AuthOverlay, getAuthConfig } from 'buzz_lib_auth';
import { ensure } from 'buzz_lib_shared';
import App from './App';
import { getLocalAuthConfig } from './auth/getLocalAuthConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const Root = _ref => {
  let {
    env
  } = _ref;
  const authConfig = env === 'local' ? getLocalAuthConfig() : getAuthConfig();

  //these will be cached up front (not mandatory)
  const initialSecrets = env === 'local' ? ['AppInsightsKey', 'buzzauthHostname', 'clapiHostname', 'SearchServiceName', 'SearchServiceContentIndex', 'SearchServiceQueryKey', 'contentfilesSas', 'buzzclstoreHostname'] : undefined;
  const infraAppUrl = env === 'local' ? 'https://buzzinfradevelop.azurewebsites.net/api/' : undefined;
  const appNavLinkGroup = {
    links
  };
  return /*#__PURE__*/_jsx(AuthOverlay, {
    authConfig: authConfig,
    children: /*#__PURE__*/_jsx(ConfigProvider, {
      env: getAppEnv(env),
      initialSecrets: initialSecrets,
      infraApiUrl: infraAppUrl,
      children: /*#__PURE__*/_jsx(AppNavProvider, {
        navLinkGroup: appNavLinkGroup,
        children: /*#__PURE__*/_jsx(App, {})
      })
    })
  });
};
const getAppEnv = env => {
  if (env === 'local') {
    return 'develop';
  } else {
    ensureAppEnv(env);
    return env;
  }
};
const handleLinkGroupClick = (ev, item) => {
  ev === null || ev === void 0 || ev.preventDefault();
  ensure(item, 'NavLink item is undefined');
  item.isExpanded = !item.isExpanded;
};
const links = [{
  name: 'Content Library',
  url: '/hive/search',
  key: 'key1',
  links: [{
    name: 'Shortlists',
    url: '/hive/shortlist',
    key: 'shorlistskey'
  }, {
    name: 'Airline Shortlists',
    url: '/hive/airline-shortlist',
    key: 'airlineshorlistskey'
  }]
}, {
  name: 'Core Config',
  url: '/core',
  key: 'key2'
}, {
  name: 'Programming',
  url: '/programming',
  key: 'key3'
}, {
  name: 'Licence and Master',
  url: '',
  onClick: handleLinkGroupClick,
  key: 'key8',
  links: [{
    name: 'Licence',
    url: '/licence/licence-orders',
    key: 'LicenceLicenceOrderListing'
  }, {
    name: 'Master',
    url: '/licence/master-orders',
    key: 'LicenceMasterOrderListing'
  }]
}, {
  name: 'Delivery Manager',
  url: '',
  key: 'key6',
  onClick: handleLinkGroupClick,
  links: [{
    name: 'Hub',
    url: '/order/materials-order-hub-listing',
    key: 'DeliveryManagerHubListing'
  }, {
    name: 'External',
    url: '/order/materials-order-external-listing',
    key: 'DeliveryManagerExternalListing'
  }]
}, {
  name: 'Image Management',
  url: '/image-orders',
  key: 'key7'
}, {
  name: 'Tool',
  url: '',
  key: 'key5',
  onClick: handleLinkGroupClick,
  links: [{
    name: 'West Excel Transform',
    url: '/tool/west-excel-transform',
    key: 'ToolSubKey1'
  }]
}, {
  name: 'Insights',
  url: '/insights',
  key: 'key4'
}];